module.exports = {
          srcSet: __webpack_public_path__ + "76a9a146.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "76a9a146.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "76a9a146.jpg",
          toString:function(){return __webpack_public_path__ + "76a9a146.jpg"},
          
          width: 330,
          height: 200
        }